import React from "react";
const RnDInitiative = () => {
  const handleGetInTouch = () => {
    // Navigate to contact us page - replace with your routing logic
    window.location.href = "/contact";
    // For React Router, you might use: navigate('/contact-us');
  };
  return (
    <>
      <section className="bg-[#2c2c2c] py-20 px-6 text-center text-white">
        <div className="text-center" data-aos="fade-up">
          <h3 className="text-3xl lg:text-4xl font-bold text-[#FFFFFF] mb-6">
            Explore how Semars can support your R&D initiatives
          </h3>

          <p className="text-lg text-gray-200 mb-8 max-w-2xl mx-auto">
            Semars helps global companies establish and expand their R&D efforts in Saudi Arabia by providing access to local expertise, resources, and strategic guidance tailored to your goals.
          </p>

          <button
            onClick={handleGetInTouch}
            className="bg-[#c99c48] text-white px-8 py-4 rounded-2xl text-lg font-semibold hover:bg-[#b88b3f] transform hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl"
          >
            Explore Now
          </button>
        </div>
      </section>
    </>
  );
};

export default RnDInitiative;
